import { FC } from 'react'
import styles from './index.module.scss'

/*
  Profile ページで使用するカードリストのコンテナ。
  display: flex; flex-wrap: wrap; と gap も指定している。
  children はカード要素のリストを想定。
  */
export const ProfileCardListGrid: FC = ({ children }) => {
  return <div className={styles.container}>{children}</div>
}
